// ThemeContext.js
import React, { createContext, useContext, useState } from 'react';

export const ThemeContext = createContext({
    theme: 'Light',
    setTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('Light');
    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
